import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import AdminDashboard from "./pages/AdminDashboard";
import AdminMembers from "./pages/AdminMembers";
import AdminSimpanan from "./pages/AdminSimpanan";
import AdminPinjaman from "./pages/AdminPinjaman";
import AdminAngsuran from "./pages/AdminAngsuran";
import AdminReports from "./pages/AdminReports";
import AdminConfig from "./pages/AdminConfig";
import AdminMasterData from "./pages/AdminMasterData";
import AdminManagementUtang from "./pages/AdminManagementUtang";
import MemberDashboard from "./pages/MemberDashboard";
import MemberProfile from "./pages/MemberProfile";
import MemberSimpanan from "./pages/MemberSimpanan";
import MemberPinjaman from "./pages/MemberPinjaman";

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-brand-muted">Memuat…</div>;
  if (user) return <Navigate to={user.role === "admin" ? "/admin" : "/dashboard"} replace />;
  return <LoginPage />;
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Toaster
          position="top-right"
          richColors
          closeButton
          toastOptions={{
            style: { fontFamily: "DM Sans, system-ui, sans-serif", borderRadius: "14px" },
          }}
        />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<RootRedirect />} />
            <Route path="/register" element={<RegisterPage />} />

            {/* Admin */}
            <Route path="/admin" element={<ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/members" element={<ProtectedRoute role="admin"><AdminMembers /></ProtectedRoute>} />
            <Route path="/admin/simpanan" element={<ProtectedRoute role="admin"><AdminSimpanan /></ProtectedRoute>} />
            <Route path="/admin/pinjaman" element={<ProtectedRoute role="admin"><AdminPinjaman /></ProtectedRoute>} />
            <Route path="/admin/angsuran" element={<ProtectedRoute role="admin"><AdminAngsuran /></ProtectedRoute>} />
            <Route path="/admin/reports" element={<ProtectedRoute role="admin"><AdminReports /></ProtectedRoute>} />
            <Route path="/admin/config" element={<ProtectedRoute role="admin"><AdminConfig /></ProtectedRoute>} />
            <Route path="/admin/master-data" element={<ProtectedRoute role="admin"><AdminMasterData /></ProtectedRoute>} />
            <Route path="/admin/management-utang" element={<ProtectedRoute role="admin"><AdminManagementUtang /></ProtectedRoute>} />

            {/* Member */}
            <Route path="/dashboard" element={<ProtectedRoute role="member"><MemberDashboard /></ProtectedRoute>} />
            <Route path="/profile" element={<ProtectedRoute role="member"><MemberProfile /></ProtectedRoute>} />
            <Route path="/simpanan" element={<ProtectedRoute role="member"><MemberSimpanan /></ProtectedRoute>} />
            <Route path="/pinjaman" element={<ProtectedRoute role="member"><MemberPinjaman /></ProtectedRoute>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
